import {NgModule} from '@angular/core';
import {AcConfigPage} from "./page/overview/config/ac-config.page";
import {AC_ENTITY_SERVICE_PROVIDERS} from "./ac.entity-provider";
import {CoreModule} from "../../core/core.module";
import {AC_TEST_PROVIDERS} from "./test/ac-test-definition";

@NgModule({
    declarations: [
        AcConfigPage,
    ],
    exports: [
        AcConfigPage,
    ],
    imports: [
        CoreModule
    ],
    providers: [AC_ENTITY_SERVICE_PROVIDERS, AC_TEST_PROVIDERS]
})
export class AcModule { }
